import React from "react";
import Card from "components/card";
import CardMenu from "components/card/CardMenu";
import BranchProfile from "./components/BranchProfile";
import BranchProduct from "./components/BranchProduct";
import CommonModal from "components/modals/Modal";
import DeleteModal from "./components/modals/DeleteModal";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { deleteBranch } from "api/BranchAPI";
import { createPortal } from "react-dom";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useDisclosure,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

const BranchesDetail: React.FC = () => {
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalAction, setModalAction] = React.useState<
    "show" | "confirmation"
  >();

  const handleDeleteBranch = () => {
    const promise = deleteBranch(slug);
    toast.promise(promise, {
      loading: "Menghapus toko...",
      success: () => {
        navigate("/admin/branches");
        return "Berhasil menghapus toko";
      },
      error: (err) => {
        return err?.response?.data?.message || "Gagal menghapus toko";
      },
    });
  };

  return (
    <>
      <Card extra={"w-full h-full px-6 pb-3 mt-3"}>
        <header className="relative flex items-center justify-between pt-4">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            Detail Toko
          </div>
          <CardMenu
            children={
              <>
                <Link
                  to={`/admin/branches/edit/${slug}`}
                  className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-brand-500 hover:font-medium hover:text-brand-600"
                >
                  <span>
                    <AiOutlineEdit />
                  </span>
                  Edit
                </Link>
                <button
                  className="mt-2 flex cursor-pointer items-center gap-2 pt-1 text-red-500 hover:font-medium hover:text-red-600"
                  onClick={() => {
                    setModalAction("confirmation");
                    onOpen();
                  }}
                >
                  <span>
                    <AiOutlineDelete />
                  </span>
                  Hapus
                </button>
              </>
            }
          />
        </header>

        <Tabs className="mt-5" variant="soft-rounded" colorScheme="green">
          <TabList className="!justify-center">
            <Tab className="aria-selected:!border-brand-500 aria-selected:font-semibold aria-selected:!text-brand-500">
              Profile
            </Tab>
            <Tab className="aria-selected:!border-brand-500 aria-selected:font-semibold aria-selected:!text-brand-500">
              Etalase
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel>
              <BranchProfile />
            </TabPanel>
            <TabPanel>
              <BranchProduct />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Card>
      {createPortal(
        <CommonModal
          size="2xl"
          children={
            <div>
              {modalAction === "confirmation" && (
                <DeleteModal
                  title="Apakah anda yakin ingin menghapus toko ini?"
                  onCancel={onClose}
                  onDelete={handleDeleteBranch}
                />
              )}
            </div>
          }
          isOpen={isOpen}
          onClose={onClose}
        />,
        document.body
      )}
    </>
  );
};

export default BranchesDetail;
